import { render, staticRenderFns } from "./PersonMissionList.vue?vue&type=template&id=6bc18ac7&"
import script from "./PersonMissionList.vue?vue&type=script&lang=js&"
export * from "./PersonMissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports